import { useParams } from "react-router-dom";
import styles from "./invoice.module.css";
import {
  Button,
  HeadingTitle,
  Image,
  Loader,
  SubHeadingTitle,
} from "../../../components/shared/index";
import { useGetOrderInvoiceQuery } from "../../../queries/useOrderQuery";
const InvoiceOrder = () => {
  const { invoiceNumber } = useParams();
  const { data, isPending, error } = useGetOrderInvoiceQuery(invoiceNumber);
  if (isPending)
    return (
      <div className={styles.loaderWrapper}>
        <Loader title="Loading Invoice..." />
      </div>
    );
  if (error) return <p>Failed to load invoice</p>;
  if (!data) return <p>No invoice found</p>;
  const order = data;
  const billing = order?.order_address || {};
  const products = order?.order_products || [];
  const shippingCost = order?.shipping_method?.cost || 0;
  const handleDownload = () => window.print();
  return (
    <section className={styles.invoiceWrapper}>
      <div className={styles.downloadBtnWrapper}>
        <Button
          title="Download Invoice"
          onHandler={handleDownload}
          style={styles.downloadBtn}
        />
      </div>
      <div className={styles.invoiceCard}>
        <div className={styles.header}>
          <div className={styles.headerLeft}>
            <Image
              src="/gdmartlogo.svg"
              alt="Anuradha Art Jewellery"
              className={styles.logo}
            />
            <HeadingTitle text="INVOICE" style={styles.invoiceTitle} /> 
            <SubHeadingTitle
              subTitle={`Invoice ID: ${order?.invoice_id}`}
              style={styles.metaText}
            />  
          
            <SubHeadingTitle
              subTitle={`Status: ${order?.order_status}`}
              style={styles.metaText}
            />
            <SubHeadingTitle
              subTitle={`Date: ${new Date(
                order?.created_at
              ).toLocaleDateString()}`}
              style={styles.metaText}
            />
          </div>
          <div className={styles.fromAddress}>
            <p>From:</p>
            <p>GD Mart</p>
            <p>Suchitra 'X' Road, City</p>
            <p>info@gdrbtechnologies.com</p>
            <p>+91 8886060799</p>
          </div>
        </div>
        <div className={styles.infoGrid}>
          <div>
            <HeadingTitle text="Bill To:" style={styles.sectionTitle} />
            <SubHeadingTitle
              subTitle={billing?.name || "-"}
              style={styles.metaText}
            />
            <SubHeadingTitle
              subTitle={billing?.email || "-"}
              style={styles.metaText}
            />
            <SubHeadingTitle
              subTitle={billing?.phone || "-"}
              style={styles.metaText}
            />
            <SubHeadingTitle
              subTitle={billing?.address || "-"}
              style={styles.metaText}
            />
            <SubHeadingTitle
              subTitle={`${billing?.city || "-"}, ${billing?.zip || "-"}`}
              style={styles.metaText}
            />
          </div>
          <div>
            <HeadingTitle text="Ship To:" style={styles.sectionTitle} />
            <p>{billing?.name || "-"}</p>
            <p>{billing?.address || "-"}</p>
            <p>
              {billing?.city || "-"}, {billing?.zip || "-"}
            </p>
            <p>{billing?.phone || "-"}</p>
          </div>
        </div>
        <div className={styles.tableWrapper}>
          <table className={styles.invoiceTable}>
            <thead>
              <tr>
                <th>PRODUCT</th> 
              
                <th>UNIT PRICE</th>
                  <th>SKU</th> 
                <th>QTY</th>
                <th>TOTAL</th> 
              </tr>
            </thead>
      
<tbody>
  {products?.map((item) => {
    const price = Number(
      item?.variant_price ??
      item?.price ??
      item?.unit_price ??
      0
    );

    const offer = Number(
      item?.variant_offer_price ??
      item?.offer_price ??
      item?.unit_price ??
      price
    );

    const hasOffer = offer > 0 && offer < price;

    const finalPrice = hasOffer ? offer : price;

    const discountPercentage =
      hasOffer && price > 0
        ? Math.round(((price - offer) / price) * 100)
        : 0;

    const sku =
      item?.variant_sku ||
      item?.sku ||
      item?.variant_item?.variant_sku ||
      "-";

    const color =
      item?.color_name ||
      item?.variant_item?.color_name;

    const size =
      item?.variant_size ||
      item?.variant_item?.variant_size;

    const quantity = Number(item?.qty ?? 0);

    return (
      <tr key={item?.id}>
        {/* PRODUCT NAME + COLOR + SIZE */}
      {/* PRODUCT NAME + VARIANT SIZE + UNIT */}
<td className={styles.productCell}>
  <div className={styles.productInfo}>
    <span className={styles.productName}>
      {item?.product_name ||
        item?.product?.name ||
        "Product"}
    </span>

    <div className={styles.variantInfo}>
      {/* Variant size and unit */}
      {(item?.variant_size || item?.variant_item?.variant_size) && (
        <span className={styles.variantTag}>
          {item?.variant_size ||
            item?.variant_item?.variant_size}
          {" "}
          {item?.unit || item?.variant_item?.unit || ""}
        </span>
      )}

      {/* Product color */}
      {(item?.color_name ||
        item?.variant_item?.color_name) && (
        <span className={styles.variantTag}>
          Color:{" "}
          {item?.color_name ||
            item?.variant_item?.color_name}
        </span>
      )}
    </div>
  </div>
</td>

        {/* UNIT PRICE + OFFER */}
        <td className={styles.priceCell}>
          <div className={styles.unitPriceBox}>
            <span className={styles.finalPrice}>
              ₹ {finalPrice.toFixed(2)}
            </span>

            {hasOffer && (
              <div className={styles.offerRow}>
                <span className={styles.originalPrice}>
                  ₹ {price.toFixed(2)}
                </span>

                <span className={styles.discountText}>
                  {discountPercentage}% OFF
                </span>
              </div>
            )}
          </div>
        </td>

        {/* SKU */}
        <td>
          <span className={styles.skuText}>
            {sku}
          </span>
        </td>

        {/* QUANTITY */}
        <td>{quantity}</td>

        {/* TOTAL */}
        <td className={styles.priceCell}>
          <span className={styles.totalPrice}>
            ₹ {(finalPrice * quantity).toFixed(2)}
          </span>
        </td>
      </tr>
    );
  })}
</tbody>

          </table>
        </div>
        <div className={styles.bottomSection}>
          <div>
            <p>Order Status: {order?.order_status}</p>
            <p>Payment Status: {order?.payment_status}</p>
          </div>
          <div className={styles.summary}>
            <div className={styles.summaryRow}>
              <span>Subtotal:</span>
              <span>₹ {order?.sub_total}</span>
            </div>
             <div className={styles.summaryRow}>
              <span>GST (0%) :</span>
              <span>₹ 0</span>
            </div>
            <div className={styles.summaryRow}>
              <span>Shipping:</span>
              <span>₹ {shippingCost}</span>
            </div>
            <div className={styles.summaryRow}>
              <span>Payment Method:</span>
              <span>{order?.payment_method.toUpperCase()}</span>
            </div>
            <div className={`${styles.summaryRow} ${styles.grandTotal}`}>
              <span>Grand Total:</span>
              <span>₹ {order?.amount}</span>
            </div>
          </div>
        </div>
        <p className={styles.footerNote}>
          Thank you for shopping with us! <br />
          For support: info@gdrbtechnologies.com
        </p>
      </div>
    </section>
  );
};
export default InvoiceOrder;